import { Col, Row } from 'reactstrap';
import dayjs from "dayjs";
import { LabeledFieldForPacCoverage } from 'components/common/standardComponents';

export default function PatientCoverageInsuredDetails(props: any) {
	const patientDetails = props.patient;
    const DATE_FORMAT = 'MM/DD/YYYY';

    const formatAddress = `${patientDetails.addresses[0].addressLine1}, ${patientDetails.addresses[0].addressLine2 ? patientDetails.addresses[0].addressLine2 +', ':''} ${patientDetails.addresses[0].city}, ${patientDetails.addresses[0].state}, ${patientDetails.addresses[0].zip}`;

	return (
		<>
            <Row style={{ margin: '5px 0px' }}>
                <h5 style={{ paddingLeft: '0px', marginBottom: '0' }}>Insured Details</h5>
            </Row>
            <hr />
            <Row>
                <Col>
                    <LabeledFieldForPacCoverage
                        label='First Name'
                        value={patientDetails.firstName}
                    />
                </Col>
                <Col>
                    <LabeledFieldForPacCoverage
                        label='Middle Name'
                        value={patientDetails.middleName}
                    />
                </Col>
                <Col>
                    <LabeledFieldForPacCoverage
                        label='Last Name'
                        value={patientDetails.lastName}
                    />
                </Col>
            </Row>
            <hr />
            <Row>
                <Col>
                    <LabeledFieldForPacCoverage
                        label='Date of Birth'
                        value={patientDetails.dateOfBirth ? dayjs(patientDetails.dateOfBirth).format(DATE_FORMAT) : ''}
                    />
                </Col>
                <Col>
                    <LabeledFieldForPacCoverage
                        label='Gender'
                        value={patientDetails.gender}
                    />
                </Col>
                <Col></Col>
            </Row>
            <hr />
            <Row style={{ marginBottom: '10px' }}>
                <Col>
                    <LabeledFieldForPacCoverage
                        label='Address'
                        value={formatAddress}
                    />
                </Col>
            </Row>
		</>
	);
}
